import { createContext, useContext } from 'react'
import type { OidcState } from '../hooks/useOidc'

const OidcContext = createContext<OidcState | null>(null)

export function OidcProvider({ value, children }: { value: OidcState; children: React.ReactNode }) {
  return <OidcContext.Provider value={value}>{children}</OidcContext.Provider>
}

export function useOidcContext(): OidcState {
  const ctx = useContext(OidcContext)
  if (!ctx) throw new Error('useOidcContext must be used within OidcProvider')
  return ctx
}
